export function getArticle(code, deposit) {
    let { getArticleRequest, getArticleError, getArticleResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/stock/get_article',
        this.createBundle('app/stock/get_article', { code, deposit }, this.GET, getArticleRequest, getArticleResult, getArticleError)
    )
}
